'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = require('vue');

exports.default = Vue.component('input-prompt', {
    props: ['label', 'hideCancel', 'noprompt', 'block'],
    data: function data() {
        return {
            value: '',
            state: 'pre'
        };
    },
    created: function created() {
        if (this.noprompt) {
            this.prompt();
        }
    },

    methods: {
        prompt: function prompt() {
            var _this = this;

            this.state = 'prompt';
            this.$nextTick(function () {
                _this.$el.querySelector('input').focus();
            });
        },
        complete: function complete() {
            this.$emit('submit', this.value);
            this.state = 'pre';
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.state = 'pre';
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputPrompt"]
window._kiwi_exports.components.utils.InputPrompt = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/InputPrompt.vue
// module id = jvBq
// module chunks = 1